import { render, staticRenderFns } from "./tencentAccount.vue?vue&type=template&id=2fdc56ce&scoped=true"
import script from "./tencentAccount.vue?vue&type=script&lang=js"
export * from "./tencentAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc56ce",
  null
  
)

export default component.exports